export const sectors = [
  'Abrasives',
  'Advertising & Media',
  'Agriculture',
  'Air Conditioners',
  'Airlines',
  'Airport Management Services',
  'Aluminium & Aluminium Products',
  'Amusement Parks/Recreation/Club',
  'Animal Feed',
  'Aquaculture',
  'Auto Ancillary',
  'Automobile Two & Three Wheelers',
  'Automobiles - Dealers & Distributors',
  'Automobiles - Passenger Cars',
  'Automobiles-Tractors',
  'Automobiles-Trucks/Lcv',
  'Bank - Private',
  'Bank - Public',
  'Batteries',
  'Bearings',
  'BPO/ITeS',
  'Breweries & Distilleries',
  'Business Support',
  'Cable',
  'Carbon Black',
  'Castings/Forgings',
  'Cement & Construction Materials',
  'Ceramics/Marble/Granite/Sanitaryware',
  'Chemicals',
  'Cigarettes/Tobacco',
  'Compressors / Pumps',
  'Construction - Real Estate',
  'Construction Vehicles',
  'Consumer Durables - Domestic Appliances',
  'Consumer Durables - Electronics',
  'Consumer Food',
  'Courier Services',
  'Cycles',
  'Defence',
  'Depository Services',
  'Detergents & Soaps',
  'Diamond & Jewellery',
  'Diesel Engines',
  'Diversified',
  'Dyes & Pigments',
  'e-Commerce',
  'Edible Oil',
  'Educational Institutions',
  'Electric Equipment',
  'Electrodes & Welding Equipment',
  'Electronics - Components',
  'Engineering',
  'Engineering - Construction',
  'Engineering - Industrial Equipments',
  'Engineering Consultancy',
  'Environmental Services',
  'Fasteners',
  'Ferro & Silica Manganese',
  'Fertilizers',
  'Film Production, Distribution & Entertainment',
  'Finance - Asset Management',
  'Finance - Housing',
  'Finance - Investment',
  'Finance - NBFC',
  'Finance - Others',
  'Finance - Stock Broking',
  'Finance Term Lending',
  'Fintech',
  'Floriculture',
  'Footwear',
  'Forgings',
  'Gas Transmission/Marketing',
  'Glass',
  'Hospital & Healthcare Services',
  'Hotel, Resort & Restaurants',
  'Household & Personal Products',
  'Industrial Gases & Fuels',
  'Insurance',
  'IT - Education',
  'IT - Hardware',
  'IT - Networking',
  'IT - Software',
  'Laminates/Decoratives',
  'Leather',
  'Logistics',
  'Lubricants',
  'Medical Equipment/Supplies/Accessories',
  'Metal - Ferrous',
  'Metal - Non Ferrous',
  'Mining & Minerals',
  'Miscellaneous',
  'Oil Exploration',
  'Packaging',
  'Paints',
  'Paper & Paper Products',
  'Pesticides & Agrochemicals',
  'Petrochemicals',
  'Pharmaceuticals & Drugs',
  'Photographic Products',
  'Plastic Products',
  'Port',
  'Power Generation/Distribution',
  'Printing & Stationery',
  'Printing And Publishing',
  'Professional Services',
  'Railways Wagons',
  'Ratings',
  'Refineries',
  'Refractories',
  'Restaurants',
  'Retailing',
  'Rubber Products',
  'Ship Building',
  'Shipping',
  'Solvent Extraction',
  'Steel & Iron Products',
  'Steel/Sponge Iron/Pig Iron',
  'Sugar',
  'Tea/Coffee',
  'Telecom-Infrastructure',
  'Telecommunication - Equipment',
  'Telecommunication - Service Provider',
  'Textile',
  'Textile - Machinery',
  'Textile - Manmade Fibres',
  'Textile - Spinning',
  'Textile - Weaving',
  'Trading',
  'Transmission Towers / Equipments',
  'Travel Services',
  'TV Broadcasting & Software Production',
  'Tyres & Allied',
  'Watches & Accessories',
  'Wood & Wood Products',
];
